import { render, staticRenderFns } from "./QuestionRadioImport.vue?vue&type=template&id=32a90015&scoped=true&"
import script from "./QuestionRadioImport.vue?vue&type=script&lang=js&"
export * from "./QuestionRadioImport.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRadioImport.vue?vue&type=style&index=0&id=32a90015&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a90015",
  null
  
)

export default component.exports